import { render, staticRenderFns } from "./GoodChart.vue?vue&type=template&id=47c951a3&scoped=true"
import script from "./GoodChart.vue?vue&type=script&lang=js"
export * from "./GoodChart.vue?vue&type=script&lang=js"
import style0 from "./GoodChart.vue?vue&type=style&index=0&id=47c951a3&prod&scoped=true&lang=css"
import style1 from "./GoodChart.vue?vue&type=style&index=1&id=47c951a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c951a3",
  null
  
)

export default component.exports